module.exports = __webpack_public_path__ + "img/xinwen3.8d9a6dcb.jpg";